<template>
  <SAISelect
    class="full-width"
    :options="leases"
    option-value="id"
    option-label="vehicleRego"
    placeholder="Select"
    :value="lease.id ? lease : undefined"
    :disable="leases.length === 1 || disable"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import { SAISelect } from 'ecx.saigon.ui.common';

export default {
  name: 'LeaseSelect',
  props: {
    disable: Boolean,
    leases: {
      type: Array,
      default: () => []
    },
    lease: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    SAISelect
  }
};
</script>
